export const getExtension = (arg) => {
  let re = /(?:\.([^.]+))?$/;
  return re.exec(arg)[1];
};
